module.exports = __webpack_public_path__ + "img/Thumb_HotRoll.ea8b889c.jpg";